// Removed unused 'lazy' and 'Navigate' imports
import { Navigate, useRoutes } from 'react-router-dom';
import AdminLogin from './pages/admin/Login';
import RegisterPage from './pages/admin/Register';
import Dashboard from './pages/Dashboard';
import TLDashboard from './pages/TLDashboard';
import TLLiveDashboard from './pages/TLLiveDashboard';
import Records from './pages/Records';
import Inventory from './pages/Inventory';
import Settings from './pages/Settings';
// import CalendarPage from './components/calendar/calendar';
import CalendarPage from './components/Calendar/Calendar';
import CommonLoginPage from './pages/admin/commonLogin';
import AdminLoginPage from './pages/admin/adminLogin';
import StudentLoginPage from './pages/admin/studentLogin';
import AICopilot from './pages/ai-copilot/AICopilot';
import Training from './pages/Training';
import { useState } from 'react';
import ProtectedRoute from './utils/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import Messages from './pages/Messages';
import OrganizationAdmin from './pages/admin/organizationalAdmin';
import ProfilePage from './pages/Profile';
import Project from './pages/admin/Projects';
import PublicRoute from './utils/PublicRoute';
import RegisterInstructions from './pages/admin/registorInstruction';
import ProfileCapture from './pages/admin/profileCapture';
import PreviewAdmin from './pages/admin/previewAdmin';
import DetailedPreview from './pages/admin/detailedPreview';
import RegisterMoreDetails from './pages/admin/registerMoreDetails';
import ChatBar from './components/Messaging/Chatbar';
import { useNavigate } from 'react-router-dom';
import CheckStatus from './pages/admin/checkStatus';
import ForgotPassword from './pages/admin/ForgotPassword';
import RestPassword from './pages/admin/restPassword';
import ProfileResubmit from './pages/admin/ProfileResubmit';
import ResubmitInstruction from './pages/admin/ResubmitInstruction';

export const AppRoutes = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const routes = [
    { path: '*', element: <Navigate to="/dashboard" replace /> },
    {
      path: '/messages',
      element: (
        <ProtectedRoute>
          <Messages collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/dashboard',
      element: (
        <ProtectedRoute>
          <Dashboard collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/inventory',
      element: (
        <ProtectedRoute>
          <Inventory collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/records',
      element: (
        <ProtectedRoute>
          <Records collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/settings',
      element: (
        <ProtectedRoute>
          <Settings collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/calendar',
      element: (
        <ProtectedRoute>
          <CalendarPage collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
  path: '/ai-copilot',
  element: (
    <ProtectedRoute>
      <AICopilot collapsed={collapsed} setCollapsed={setCollapsed} />
    </ProtectedRoute>
  ),
},
    {
      path: '/training',
      element: (
        <ProtectedRoute>
          <Training collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/profile',
      element: (
        <ProtectedRoute>
          <ProfilePage collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/tl-live',
      element: (
        <ProtectedRoute>
          <TLLiveDashboard collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/project',
      element: (
        <ProtectedRoute>
          <Project collapsed={collapsed} setCollapsed={setCollapsed} />
        </ProtectedRoute>
      ),
    },
    {
      path: '/register',
      element: (
        <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      ),
    },
    {
      path: '/login',
      element: (
        <PublicRoute>
          <CommonLoginPage />
        </PublicRoute>
      ),
    },
    {
      path: '/adminlogin',
      element: (
        <PublicRoute>
          <AdminLoginPage />
        </PublicRoute>
      ),
    },
    {
      path: '/mbf-admin-login',
      element: (
        <PublicRoute>
          <OrganizationAdmin />
        </PublicRoute>
      ),
    },
    {
      path: '/register-instructions',
      element: (
        <PublicRoute>
          <RegisterInstructions />
        </PublicRoute>
      ),
    },
    {
      path: '/profile-capture',
      element: (
        <PublicRoute>
          <ProfileCapture />
        </PublicRoute>
      ),
    },
    {
      path: '/re-upload-instructions',
      element: (
        <ProtectedRoute>
          <ResubmitInstruction />
        </ProtectedRoute>
      ),
    },
    {
      path: '/profile-recapture',
      element: (
        <ProtectedRoute>
          <ProfileResubmit />
        </ProtectedRoute>
      ),
    },
    {
      path: '/register-submit-1',
      element: (
        <PublicRoute>
          <PreviewAdmin />
        </PublicRoute>
      ),
    },
    {
      path: '/register-submit-2',
      element: (
        <PublicRoute>
          <DetailedPreview />
        </PublicRoute>
      ),
    },
    {
      path: '/register-submit-3',
      element: (
        <PublicRoute>
          <RegisterMoreDetails />
        </PublicRoute>
      ),
    },
    {
      path: '/chat_bar',
      element: (
        <PublicRoute>
          <ChatBar />
        </PublicRoute>
      ),
    },
    {
      path: '/forgot_password',
      element: (
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      ),
    },
    {
      path: '/reset_password',
      element: (
        <PublicRoute>
          <RestPassword />
        </PublicRoute>
      ),
    },
    {
      path: '/check-status',
      element: (
        <PublicRoute>
          <CheckStatus />
        </PublicRoute>
      ),
    },
    // More routes can be added here
  ];

  return useRoutes(routes);
};
